import { TbRosetteDiscount } from "react-icons/tb";
import FormTitle from "../../../components/FormTitle/FormTitle";
import { useEffect, useState } from "react";
import { useListManager } from "../../../contexts/list.manager";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader/Loader";
import Form from "../../../components/Form/Form";
import Input from "../../../components/Input/Input";
import TextAreaInput from "../../../components/TextAreaInput/TextAreaInput";
import LicenseService from "../../../services/LicensesService";
import { MdOutlineCategory } from "react-icons/md";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import { BsToggles } from "react-icons/bs";
import { BiDollar } from "react-icons/bi";
import { AnimatedTabbar, AnimatedTabbarItem } from "../../../components/AnimatedTabbar/AnimatedTabbar";
import { BillingPeriod, BillingPeriodMonths, BillingPeriodText, BillingPeriodUnit } from "../../../constants/billing";
import { formatMoney, parseMoney } from "../../../utils/number";
import Button from "../../../components/Button/Button";
import { FaArrowTrendUp } from "react-icons/fa6";
import ModalComponent from "../../../components/Modal/ModalComponent";
import { PriceInput } from "../../../components/PriceInput/PriceInput";
import { capitalize, numberToMoney } from "../../../utils/string";
import { useTranslation } from "react-i18next";
import { LOCALES } from "../../../components/Datetime/Datetime";
import { DatetimeWithRelative } from "../../../components/DatetimeWithRelative/DatetimeWithRelative";
import { TimeAgo } from "../../../components/TimeAgo/TimeAgo";
import { IoAddCircleOutline } from "react-icons/io5";
import Pagination from "../../../components/Pagination/Pagination";
import List from "../../../components/List/List";
import { CurrentPrice } from "../../../components/CurrentPrice/CurrentPrice";
import { PricesByPeriod } from "../../../components/PricesByPeriod/PricesByPeriod";

export function FormLicenseFeature({ title, ...props }) {
   const [code, setCode] = useState(props.licenseFeature?.code);
   const [name, setName] = useState(props.licenseFeature?.name);
   const [enabled, setEnabled] = useState(props.licenseFeature?.enabled);
   const [system, setSystem] = useState(props.licenseFeature?.system);
   const [description, setDescription] = useState(props.licenseFeature?.description);
   const [metadata, setMetadata] = useState(props.licenseFeature?.metadata);
   const [currentPrices, setCurrentPrices] = useState(props.licenseFeature?.currentPrices ?? {});
   const [lastPrices, setLastPrices] = useState(props.licenseFeature?.lastPrices ?? {});

   const [isSubmitting, setIsSubmitting] = useState(false);
   const [showLoader, setShowLoader] = useState(false);
   const { closeForm } = useListManager();
   const navigate = useNavigate();
   const [activeTab, setActiveTab] = useState(BillingPeriod.MONTHLY);

   const [showAdjustModal, setShowAdjustModal] = useState(false);
   const [adjustState, setAdjustState] = useState({
      lastPrice: null,
      newAmount: null,
      startDate: null,
   });

   const { t, i18n } = useTranslation();

   useEffect(() => {
      setCode(props.licenseFeature?.code || "");
      setName(props.licenseFeature?.name || "");
      setEnabled(props.licenseFeature?.enabled || false);
      setSystem(props.licenseFeature?.system || false);
      setDescription(props.licenseFeature?.description || "");
      setMetadata(props.licenseFeature?.metadata || "");
      setCurrentPrices(props.licenseFeature?.currentPrices);
      setLastPrices(props.licenseFeature?.lastPrices);
   }, [props.licenseFeature])

   function buildPayload() {
      const adjustments = {};

      Object.entries(currentPrices).map(([period, price]) => {
         if (!price.id) {
            adjustments[period] = price;
         }
      });

      const payload = {
         code,
         name,
         enabled: enabled ?? false,
         system: system ?? false,
         description,
         metadata,
         currentPrices,
      };
      return payload;
   }

   async function handleSubmit(event) {
      event.preventDefault();
      if (props.type === "edicao") {
         setIsSubmitting(true);
         await handleEdit(event);
         setIsSubmitting(false);
         return;
      }
      setIsSubmitting(true);
      const payload = buildPayload();
      const response = await LicenseService.createFeature(payload);
      if (!response) return;
      if (response.data.id) navigate("/licenses/features", {
         state: { refresh: true }
      });
      setIsSubmitting(false);
   }

   async function handleEdit(event) {
      event.preventDefault();
      const payload = buildPayload();
      const response = await LicenseService.updateFeature(
         props.licenseFeature.id,
         payload
      );
      closeForm();
      if (response.data.id) navigate("/licenses/features");
   }

   async function handleDelete() {
      if (!props.licenseFeature) return;
      await LicenseService.deleteFeature(props.licenseFeature.id);
      navigate("/licenses/features", {
         state: { deletedId: props.licenseFeature.id },
      });
   }

   const handleClickEditButton = () => {
      if (!props.licenseFeature) return;
      navigate(`/licenses/features/${props.licenseFeature.externalId}`, { state: props.licenseFeature });
   };

   function openAdjustModal(period, lastPrice = null) {
      setShowAdjustModal(true);
      setAdjustState({
         period,
         lastPrice,
         newAmount: lastPrice?.amount,
         startDate: lastPrice?.startDate,
      })
   }

   function closeAdjustModal(lastPrice) {
      setShowAdjustModal(false);
      setAdjustState({
         lastPrice: null,
         newAmount: null,
      })
   }

   return (
      <>
         <FormTitle
            type={props.type}
            icon={<BsToggles size={20} />}
            tituloConsulta={props.licenseFeature?.name || null}
            tituloCadastro={title || "Cadastro de Funcionalidade de Licença"}
            backRoute={"/licenses/features"}
         />
         {showLoader ? (
            <Loader />
         ) : (
            <Form
               handleSubmit={handleSubmit}
               handleClickEdit={handleClickEditButton}
               type={props.type}
               handleDelete={handleDelete}
               navigateCancelUrl="/licenses/features"
               isSubmitting={isSubmitting}
            >
               <div className={props.type === 'consulta' ? `w-full` : 'grid-2'}>
                  <Input
                     name="name"
                     id="name"
                     labelText="Nome *"
                     value={name}
                     onChange={({ target }) => setName(target.value)}
                     disabled={props.type === "consulta" || isSubmitting}
                     required={true}
                  />
                  <Input
                     name="code"
                     id="code"
                     labelText="Código *"
                     value={code}
                     onChange={({ target }) => setCode(target.value)}
                     disabled={props.type === "consulta" || isSubmitting}
                     required={true}
                  />
               </div>
               <TextAreaInput
                  name={"description"}
                  id="description"
                  labelText={"Informações extras"}
                  onChange={({ target }) => setDescription(target.value)}
                  value={description}
                  hidden={props.type === "consulta" || isSubmitting}
                  rows={3}
               />
               <div className={`flex ${props.type === 'consulta' ? 'flex-col' : 'flex-row'} justify-start w-full gap-5!`}>
                  <ToggleButton
                     label="Habilitado"
                     defaultChecked={enabled}
                     onChange={({ target }) => setEnabled(target.checked)}
                     required={false}
                     disabled={props.type === "consulta" || isSubmitting}
                     tooltipVisible={true}
                  />
                  <ToggleButton
                     label="Padrão do sistema"
                     defaultChecked={system}
                     onChange={({ target }) => setSystem(target.checked)}
                     required={false}
                     disabled={props.type !== "cadastro" || isSubmitting}
                     tooltipVisible={true}
                  />
               </div>

               {props.type !== 'consulta' && (
                  <>
                     <div className="w-full mt-5! mb-1.5!" style={{ gap: 25 }}>
                        <h1 className="flex flex-row items-center gap-2! font-semibold! text-[1rem]! mb-2! text-left w-full text-(--textColor)">
                           <BiDollar size={19} />
                           Preços por período
                        </h1>
                        <AnimatedTabbar
                           value={activeTab}
                           onChange={setActiveTab}
                        >
                           {Object.values(BillingPeriod).map(period => (
                              <AnimatedTabbarItem name={period}>
                                 {BillingPeriodText[period]}
                              </AnimatedTabbarItem>
                           ))}
                        </AnimatedTabbar>
                     </div>
                     {Object.values(BillingPeriod).filter(period => activeTab === period).map(period => (
                        <>
                           <div className="w-full text-left text-(--textColor)">
                              <CurrentPrice
                                 currentPrices={currentPrices}
                                 period={period}
                              />
                              <Button
                                 label={props.type === 'cadastro' ? "Configurar preço" : "Ajustar preço"}
                                 icon={props.type === 'cadastro' ? <IoAddCircleOutline size={22} /> : <FaArrowTrendUp />}
                                 onClick={e => openAdjustModal(period, currentPrices?.[period])}
                                 className="button-link mt-3!"
                                 disabled={isSubmitting}
                              />
                           </div>
                           {props.type === 'edicao' && props.licenseFeature && (
                              <PricesByPeriod period={period} resourceId={props.licenseFeature.id} resourceType="feature" />
                           )}
                        </>
                     ))}
                  </>
               )}
            </Form>
         )}
         <ModalComponent
            modalIsOpen={showAdjustModal}
            handleConfirm={() => {
               setLastPrices(prev => ({
                  ...prev,
                  [adjustState.period]: currentPrices?.[adjustState.period]
               }));
               setCurrentPrices(prev => ({
                  ...prev,
                  [adjustState.period]: {
                     amount: adjustState.newAmount,
                     period: adjustState.period,
                     startDate: adjustState.startDate,
                  }
               }));
               closeAdjustModal();
            }}
            handleCancel={() => closeAdjustModal()}
            modalText={props.type === 'edicao' ? "Ajustar preço" : "Configurar preço"}
            buttonLabel1={"Confirmar"}
         >
            <div className="w-[420px] max-w-dvw flex flex-col gap-3">
               <PriceInput
                  name="amount"
                  id="amount"
                  labelText={props.type === 'edicao' ? "Novo valor" : 'Valor'}
                  value={formatMoney(adjustState.newAmount ?? 0)}
                  onChange={({ target }) =>
                     setAdjustState(prev => ({ ...prev, newAmount: Number(target.value) || 0 }))
                  }
                  required={true}
                  tooltipText={props.type === 'edicao' ? `Novo valor ajustado para o período ${BillingPeriodText[adjustState.period]}.` : `Valor para o período ${BillingPeriodText[adjustState.period]}.`}
                  tooltipVisible={true}
               />
               <Input
                  type="date"
                  labelText="Data de Inicio"
                  value={adjustState.startDate}
                  onChange={({ target }) =>
                     setAdjustState(prev => ({ ...prev, startDate: target.value }))
                  }
                  required={false}
                  disabled={props.type === "consulta"}
                  tooltipText={props.type === 'edicao' ? "Inicio da vigência do ajuste" : "Inicio da vigência"}
                  tooltipVisible={true}
               />
            </div>
         </ModalComponent>
      </>
   );
}